
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 137718","xmlns":"http://www.w3.org/2000/svg","width":"38","height":"38","viewBox":"0 0 38 38"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 140830"}},[_c('rect',{attrs:{"data-name":"Rectangle 111203","width":"38","height":"38","rx":"19","fill":"#edf0f5","opacity":".4"}}),_c('g',{attrs:{"fill":"#8d98aa","data-name":"vuesax/twotone/user"}},[_c('path',{attrs:{"d":"M19 10.043a4.791 4.791 0 11-4.791 4.791A4.8 4.8 0 0119 10.043zm0 8.333a3.541 3.541 0 10-3.541-3.542A3.545 3.545 0 0019 18.376z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M26.157 27.958a.625.625 0 01-.625-.625c0-2.872-2.93-5.208-6.532-5.208s-6.533 2.336-6.533 5.208a.625.625 0 01-.625.625.625.625 0 01-.625-.625 5.926 5.926 0 012.328-4.608A8.63 8.63 0 0119 20.875a8.63 8.63 0 015.454 1.85 5.926 5.926 0 012.328 4.61.625.625 0 01-.625.623z","opacity":".4"}})])])])
          )
        }
      }
    